import { ManualField } from '../ManualFieldInput/ManualFieldInput.types';

export const USER_NAME_FIELDS: ManualField[] = [
  { field: 'firstName', placeholderKey: 'firstName' },
  { field: 'lastName', placeholderKey: 'lastName' },
];

export const AttestationOccupations = [
  'Foreign exchange branch owner',
  'Foreign Exchange',
  'Gas station owner',
  'Tobacco Distributor',
  'Automotive Dealer',
  'Accounts Receivable Assistant',
  'Accounts Receivable Clerk',
  'Addictions Counselor Assistant',
  'Administrative Clerk',
  'Automated Teller Machines (ATM) Owner',
  'Privately owned automated teller machines (ATM)',
  'Air Traffic Coordinator',
  'Airplane Dispatch Clerk',
  'Anesthesiologist Assistant',
  'Appliance Parts Counter Clerk',
  'Assistant Attorney General',
  'Assistant Counsel',
  'Assistant Innkeeper',
  'Assistant Instructor',
  'Assistant Paralegal',
  'Assistant Professor',
  'Assistant Store Manager',
  'Auditing Clerk',
  'Autopsy Assistant',
  "Baker's Assistant",
  'Bank Vault Clerk',
  'Banking Services Clerk',
  'Betting Clerk',
  'Bicycle Rental Clerk',
  'Billing Clerk',
  'Biology Laboratory Assistant',
  'Boat Rental Clerk',
  'Braille & Talking Books Clerk',
  'Budget Coordinator',
  'Car Rental Clerk',
  'Catalogue Clerk',
  'Census Clerk',
  'Childcare Center Administrator',
  'Chiropractic Assistant',
  'Circuit Court Clerk',
  'City Clerk',
  'Claims Correspondence Clerk',
  'Classified Ad Clerk',
  'Clerk of Court',
  'Clerk Typist',
  'Clinical Medical Assistant',
  'Collections Clerk',
  'Commodities Clerk',
  'Complaint Clerk',
  'Construction Coordinator',
  'Contract Administrator',
  'Court Clerk',
  'Courtroom Clerk',
  'Credit Reference Clerk',
  'Curriculum Coordinator',
  'Customer Complaint Clerk',
  'CS Correspondence Clerk',
  'Customs Entry Clerk',
  'Data Analysis Assistant',
  'Data Entry/Input Clerk',
  'Data Processing Clerk',
  'Database Coordinator',
  'Dental Assistant',
  'Dental Secretary',
  'Deputy Court Clerk',
  'Direct Mail Clerk',
  'Dividend Clerk',
  "Doctor's Assistant",
  'Document Clerk',
  'Economic Research Assistant',
  'Editorial Assistant',
  'Election Clerk',
  "Electrician's Assistant",
  'Employment Clerk',
  'Executive Assistant',
  'Flight Crew Time Clerk',
  'Flight Operations Coordinator',
  'Foreign Exchange Clerk',
  'Freight Clerk',
  'Front Desk Receptionist',
  'Funding Coordinator',
  'Funeral Assistant',
  'Funeral Home Assistant',
  'Health Services Administrator',
  'Healthcare Administrator',
  'Hospital Administrator',
  'Hospital Secretary',
  'Hotel Receptionist',
  'Human Resources Clerk',
  'Incoming Freight Clerk',
  'Index Clerk',
  'Insurance Clerk',
  'Insurance Examining Clerk',
  'Insurance Policy Issue Clerk',
  'Inventory Control Clerk',
  'Invoice Clerk',
  'Invoice Control Clerk',
  'jobal Therapy Assistant',
  'Judicial Clerk',
  'LAN (Systems) Administrator',
  'Law Secretary',
  'Legal Assistant',
  'Legal Secretary',
  'Library Clerk',
  'License Clerk',
  'Logistics Coordinator',
  'Mail Order Clerk',
  'Mailroom Clerk',
  'Marketing Administrator',
  'Masonry Contract Administrator',
  'Material Control Clerk',
  'Meat Clerk',
  "Mechanic's Assistant",
  'Medical Assistant',
  'Medical Records Administrator',
  'Mortgage Accounting Clerk',
  'Mortgage Loan Processing Clerk',
  'Motel Clerk',
  'Motor Vehicle License Clerk',
  'Multimedia Service Coordinator',
  'Municipal Clerk',
  'Network Coordinator',
  'Network Support Coordinator',
  'Network Systems Administrator',
  'Nursing Assistant',
  'Office Assistant',
  'Office Clerk',
  'Office Secretary',
  'Optometry Assistant',
  'Order Desk Clerk',
  'Orthodontic Assistant',
  'Packaging Clerk',
  'Parcel Post Clerk',
  'Pension Administrator',
  'Personal Secretary',
  'Personnel Administrator',
  'Pharmacist Assistant',
  'Pharmacy Assistant',
  'Pharmacy Clerk',
  'Physical Therapy Assistant',
  'Physiotherapy Assistant',
  'Pit Clerk',
  'Plumber Assistant',
  'Postal Clerk',
  'Postal Service Window Clerk',
  'Prescription Clerk',
  'Press Secretary',
  'Probate Clerk',
  'Procurement Assistant',
  'Psychiatric Secretary',
  'Public Health Administrator',
  'Purchasing Assistant',
  'Real Estate Clerk',
  'Receiving Clerk',
  'Records Clerk',
  'Rental Clerk',
  'Research Assistant',
  'Resort Desk Clerk',
  'Safety Coordinator',
  'Sales Clerk Supervisor',
  'Scale Clerk',
  'Securities Clerk',
  'Service Order Clerk',
  'Shipping and Receiving Clerk',
  'Shipping Order Clerk',
  'Social Work Assistant',
  'Sound Assistant',
  'Staffing Coordinator',
  'Statement Clerk',
  'Statistical Clerk',
  'Stockroom Attendant / Clerk',
  'Store Receiving Clerk',
  'Student Admissions Clerk',
  'Subscription Clerk',
  'Supply Clerk',
  'Surgical Assistant',
  'Tax Clerk',
  'Teaching Assistant',
  'Time and Attendance Clerk',
  'Tour Coordinator',
  'Township Clerk',
  'Train Clerk',
  'Train Reservation Clerk',
  'Training Coordinator',
  'Transportation Clerk',
  'Travel Agency Clerk',
  'Underwriting Assistant',
  'Underwriting Clerk',
  'University Teaching Assistant',
  'Veterinarian Assistant',
  'Video Production Assistant',
  'Wardrobe Assistant',
  'Warehouse Clerk',
  'Warrant Clerk / Server',
  'Warranty Clerk',
  'Agricultural Agent',
  'Agricultural Chemist',
  'Agricultural Economist',
  'Agricultural Engineer',
  'Agricultural Research',
  'Agronomist',
  'Beef Farm Operator',
  'Dairy Farm Manager',
  'Farm Equipment Engineer',
  'Farm Labor Contractor',
  'Farm Management',
  'Farm Manager',
  'Farmer',
  'Horticulturist',
  'Purchasing Agent Farm Products',
  'Animal Breeder',
  'Animal Care',
  'Animal Control',
  'Animal Cruelty Investigator',
  'Animal Groomer',
  'Animal Shelter Worker',
  'Animal Surgeon',
  'Animal Trainer',
  'Carpet Installer / Layer',
  'Pet Feeder',
  'Pet Groomer',
  'Pet Sitter',
  'Pet Stylist',
  'Pet Supplies Salesperson',
  'Petroleum Engineer',
  'Petroleum Geologist',
  'Petroleum Plant Operator',
  'Petroleum Refinery Operator',
  'Petroleum Technician',
  'Pets Salesperson',
  'Predatory Animal Exterminator',
  'Predatory Animal Hunter',
  'Predatory Animal Trapper',
  'Puppeteer',
  'Veterinarian',
  'Veterinary',
  'Veterinary Lab Tech',
  'Veterinary Technician',
  'Zookeeper',
  'Artist Manager',
  'Artist Representative',
  'Auto Painter',
  'Boat Painter',
  'Bridge Painter',
  'Caricature Artist',
  'Ceramic Painter',
  'Collections Curator',
  'Comic Artist',
  'Comic Book Artist',
  'Commercial Artist',
  'Concrete Sculptor',
  'Crafts Artist',
  'Dance Artist',
  'Display Artist',
  'Free Lance Artist',
  'Funeral Home Makeup Artist',
  'Glass Artist',
  'Graphic Artist',
  'House Painter',
  'Ice Sculptor',
  'Multimedia Artist',
  'Museum Curator',
  'Portrait Artist',
  'Portrait Painter',
  'Radio Artist',
  'Roof Painter',
  'Ship Painter',
  'Sketch Artist',
  'Special Effects Artist',
  'Special Effects Makeup Artist',
  'Tattoo Artist',
  'Voice-Over Artist',
  'Wedding Makeup Artist',
  'Advertising Executive',
  'Advertising Manager',
  'Air Operations Manager',
  'Airport Manager',
  'Amusement Park Manager',
  'Apartment Manager',
  'Athletic Equipment Manager',
  'Band Manager',
  'Bank Branch Manager',
  'Banking (Center) Manager',
  'Banquet Manager',
  'Bar Manager',
  'Boat Club Manager',
  'Booking Manager',
  'Business Analyst',
  'Business Consultant',
  'Business Management Analyst',
  'Business Office Manager',
  'Business Process Consultant',
  'Business Services Sales Agent',
  'Business Teacher',
  'Business Unit Manager',
  'Cafeteria Manager',
  'Cardroom Manager',
  'Cashier Manager',
  'Casino Manager',
  'Chief Executive Officer',
  'Classified Advertising Manager',
  'Club Manager',
  'Communication Manager',
  'Community Association Manager',
  'Compliance Manager',
  'Computer Operations Manager',
  'Conference Center Manager',
  'Conference Services Manager',
  'Contracting Manager',
  'Convention Services Manager',
  'Credit Manager',
  'Data Processing Manager',
  'Department Store Manager',
  'Distribution Center Manager',
  'District Sales Manager',
  'Donor Relations Manager',
  'E-Learning Manager',
  'Employee Benefits Manager',
  'Employee Development Manager',
  'Employee Relations Manager',
  'Events Manager',
  'Executive Casino Host',
  'Export Manager',
  'Fight Manager',
  'Fiscal Manager',
  'Fitness Club Manager',
  'Flight Service Manager',
  'Food and Beverage Manager',
  'Funeral Home Manager',
  'Global Engineering Manager',
  'Golf Club Manager',
  'Government Service Executive',
  'Greenhouse Manager',
  'Harvest Manager',
  'Hatchery Manager',
  'Health Care Manager',
  'Hotel Manager',
  'Information Services Manager',
  'Information Systems Manager',
  'Sales Advertising Executive',
  'Intelligence Manager',
  'International Bank Manager',
  'Internet Marketing Manager',
  'Internet Technology Manager',
  'Labor Training Manager',
  'Leasing Property Manager',
  'Locker Room Manager',
  'Lodging Facilities Manager',
  'Logistics Manager',
  'Mental Health Program Manager',
  'Mortgage Manager',
  'Nail Salon Manager',
  'Network Support Manager',
  'Nursing Home Manager',
  'Office Manager',
  'Operational Risk Manager',
  'Operations Manager',
  'Orchard Manager',
  'Payroll Manager',
  'Personnel Manager',
  'Plant Manager',
  'Process Manager',
  'Procurement Manager',
  'Production Control Manager',
  'Production Manager',
  'Promotions Manager',
  'Property Manager',
  'Public Relations Manager',
  'Radio Station Manager',
  'Real Estate Manager',
  'Records & Information Manager',
  'Regional Sales Manager',
  'Restaurant Manager',
  'Sales Account Manager',
  'Skating Rink Manager',
  'Ski Resort Manager',
  'Slot Shift Manager',
  'Slots Manager',
  'Social Science Manager',
  'Sourcing Manager',
  'Stadium Manager',
  'Stage Manager',
  'Stallion Manager',
  'Table Games Manager',
  'Talent Manager',
  'Tavern Manager',
  'Telemarketing Manager',
  'Television Store Manager',
  'Tennis Club Manager',
  'Territory Sales Manager',
  'Theme Park Manager',
  'Transportation Manager',
  'Travel Agency Manager',
  'Travel Executive',
  'Utilities Manager',
  'Warehouse Manager',
  'Wellness Manager',
  'Community Development Planner',
  'Community Organization Worker',
  'Community Service Director',
  'Social Worker',
  'Architectural Designer',
  'Architectural Engineer',
  'Architectural Inspector',
  'Assembling Motor Builder',
  'Battery Builder',
  'Beam Builder',
  'Blockmason',
  'Bricklayer / Brickmason',
  'Building Architect',
  'Building Carpenter',
  'Cabinet Builder',
  'Carpenter',
  'Cement Mason',
  'Chimney Builder',
  'Concrete Mason',
  'Data Architect',
  'Elevator Constructor',
  'Engine Builder',
  'Fence Builder',
  'Guitar Builder',
  'Landscape Architect',
  'Machine Builder',
  'Marine Architect',
  'Mason',
  'Masonry Instructor',
  'Plastic Jig & Fixture Builder',
  'Rock Mason',
  'Software Application Architect',
  'Structural Architect',
  'Systems Architect',
  'Tile Mason',
  'Truck Transmission Builder',
  'Web Architect',
  'Wood Stair Builder',
  'Adult Education Teacher',
  'Associate Professor',
  'Basic Studies Teacher',
  'Biology Teacher',
  'College Professor',
  'Early Childhood Teacher',
  'Elementary School Teacher',
  'ESL Teacher',
  'English Teacher',
  'French Teacher',
  'Health Educator',
  'High School Teacher',
  'History Teacher',
  'Horticultural Services',
  'Kindergarten Teacher',
  'Literacy Teacher',
  'Math Teacher',
  'Music Librarian',
  'Nursery School Teacher',
  'PE Teacher',
  'Public Health Educator',
  'Reading Teacher',
  'Research Professor',
  'School Librarian',
  'Science Teacher',
  'Social Studies Teacher',
  'Special Education Teacher',
  'Substitute Teacher',
  'Technology Education Teacher',
  'University Librarian',
  'University Professor',
  'Yoga Instructor / Teacher',
  'Bank Courier',
  'Armed Forces - Logistics',
  'Courier',
  'Freight Shipping Agent',
  'Logistics Analyst',
  'Logistics Planner',
  'Logistics Specialist',
  'Logistics Supply Officer',
  'Shipping&Receiving Material',
  'Warehouse Supervisor',
  'Airplane Electrician',
  'Armature Rewinder',
  'Auto Electrician',
  'Beer Coil Cleaner',
  'Boiler Engineer',
  'Boiler Fitter / Installer',
  'Boiler Mechanic',
  'Boiler Operator',
  'Boiler Plant Operator',
  'Boiler Room Operator',
  'Chief Electrician',
  'Electrician',
  'Gas Fitter',
  'Gas Station Attendant',
  'Gas Station Supervisor',
  'High Pressure Boiler Operator',
  'Gas Compressor Station Ops',
  'Locomotive Electrician',
  'Natural Gas Engineer',
  'Oil Exploration Engineer',
  'Oil Field Worker',
  'Oil Pipeline Dispatcher',
  'Oil Pipeline Operator',
  'Oil Refiner',
  'Oil Rig Driller',
  'Oil Rig Floorhand',
  'Oil Rig Roughneck',
  'Oil Well Driller',
  'Oil Well Engineer',
  'Oil Well Pumper',
  'Oilfield Plant/Field Operator',
  'Powerhouse Electrician',
  'PV / Solar Panel Installer',
  'Solar Panel / PV Electrician',
  'Solar Thermal Installer',
  'Stage Electrician',
  'Wind Energy Mechanic',
  'Winder Operator',
  'Window/Glass Cleaning Services',
  'Window Decorator',
  'Window Draper',
  'Window Dresser',
  'Window Shade Installer',
  'Windshield Installer',
  'Wire Winder',
  'A&P Mechanic',
  'Ab-/Adsorption Engineer',
  'Advertising Analyst',
  'Aerodynamics Engineer',
  'Aeronautical Engineer',
  'AC Service Technician',
  'Air Pollution Control Engineer',
  'Air Quality Technician',
  'Aircraft Engineer',
  'Alarm Technician',
  'Analyst',
  'Applications Analyst',
  'APP Developer / Programmer',
  'Audio Engineer',
  'Aviation Technician',
  'Bacteriology Technician',
  'Benefits Analyst',
  'Bicycle Mechanic',
  'Bike Mechanic',
  'Biochemical Engineer',
  'Bio-Mechanical Engineer',
  'Biomedical Engineer',
  'Bridge Engineer',
  'Broadcast Engineer',
  'Budget Analyst',
  'Building (Services) Mechanic',
  'BI Developer',
  'Cable Installation Technician',
  'Calibration Engineer',
  'Armed Forces - Technician',
  'Car Mechanic',
  'Cardiac Technician',
  'Cartographic Technician',
  'Ceramic Engineer',
  'Chemical Laboratory Technician',
  'Chemical Process Engineer',
  'Chemical Research Engineer',
  'Chief Credit Analyst',
  'Circuit Design Engineer',
  'Claims Analyst',
  'Clinical Informatics Analyst',
  'Coastal Engineer',
  'Combustion Engineer',
  'Commodity Analyst',
  'Compensation Analyst',
  'Computer Application Developer',
  'Computer Applications Engineer',
  'Computer Hardware Developer',
  'Computer Laboratory Technician',
  'Computer Network Engineer',
  'Computer Service Technician',
  'Computer Systems Engineer',
  'Construction Engineer',
  'Contact Lens Technician',
  'Cost Analyst',
  'Credit Analyst',
  'Credit Risk Analyst',
  'Crime Lab Technician',
  'Crime Scene Technician',
  'Criminalist Technician',
  'Cryptologic Technician',
  'Dairy Equipment Mechanic',
  'Data Mining Analyst',
  'Data Processing System Analyst',
  'Data Visualization Developer',
  'Database Developer',
  'Dental Equipment Mechanic',
  'Dental Technician',
  'Dialysis Technician',
  'Diesel Service Technician',
  'Diet Technician',
  'Dietary Technician',
  'Digital Imaging Technician',
  'Digital Photo Technician',
  'Economic Research Analyst',
  'Efficiency Engineer',
  'EKG Technician',
  'Electrical Engineering',
  'Electromechanical Assembler',
  'Electronic Engineer',
  'Engineer, Photogrammetric',
  'Environmental Analyst',
  'Environmental Technician',
  'Ergonomics Technician',
  'Explosive Technician',
  'Facilities Engineer',
  'Ferry Engineer',
  'Fiber Optic Technician',
  'Financial Analyst',
  'Financial Risk Analyst',
  'Flight Engineer',
  'Food Quality Technician',
  'Forensic Analyst',
  'Forest Technician',
  'Genetic Engineer',
  'Geophysical Engineer',
  'Geotechnical Engineer',
  'Health and Safety Technician',
  'Hearing Aid Technician',
  'Helicopter Mechanic',
  'Help Desk Analyst',
  'Help Desk Technician',
  'Highway Engineer',
  'Hydrographic Engineer',
  'Industrial Safety Engineer',
  'Information Analyst',
  'Information Security Analyst',
  'Information Systems Analyst',
  'Intelligence Analyst',
  'Investment Analyst',
  'Jet Engine Mechanic',
  'Job Analyst',
  'jobal Analyst',
  'Legal Technician',
  'Loan Analyst',
  'Logging Operating Engineer',
  'Marine Equipment Engineer',
  'Marine Mechanic',
  'Marine Technician',
  'Market Research Analyst',
  'Marketing Analyst',
  'Mathematical Engineer',
  'Mathematics Technician',
  'Mechatronics Engineer',
  'Mechatronics Technician',
  'Medical Claims Analyst',
  'Medical Supply Technician',
  'Mental Health Technician',
  'Metallurgical Engineer',
  'Microbiological Analyst',
  'Microbiology Technician',
  'Mining Engineer',
  'Mining Technician',
  'Mobile Applications Developer',
  'Motor Scooter Mechanic',
  'Motorboat Mechanic',
  'Motorcycle Technician',
  'Network Analyst',
  'Network Developer',
  'Network Engineer',
  'Network Intelligence Analyst',
  'Network Security Analyst',
  'Network Technician',
  'Neurology Technician',
  'Nuclear Engineer',
  'Nuclear Radiation Engineer',
  'Operations Analyst',
  'Optical Engineer',
  'Orthodontic Technician',
  'Packaging Engineer',
  'Photonics Engineer',
  'Piano Technician / Tuner',
  'Pipe Organ Technician',
  'Plant Maintenance Technician',
  'Plastics Engineer',
  'Pollution Control Engineer',
  'Pollution Control Technician',
  'Powerplant Mechanic',
  'Procedure Analyst',
  'Process Analyst',
  'Process Engineering',
  'Product Safety Engineer',
  'Production Engineer',
  'Radiation Engineer',
  'Radio/Television Technician',
  'Radiologic Technician',
  'Railroad Engineer',
  'Railway Technician',
  'Reactor Engineer',
  'Recording Engineer',
  'Records Management Analyst',
  'Relations Analyst',
  'Safe and Vault Mechanic',
  'Scooter Mechanic',
  'Securities Research Analyst',
  'Seed Analyst',
  'Ships Equipment Engineer',
  'Ski Lift Mechanic',
  'Slot Technician',
  'Software Applications Engineer',
  'Software Developer',
  'Software Engineer',
  'Software Quality Engineer',
  'Software Systems Engineer',
  'Software Test Engineer',
  'Sound Effects Technician',
  'Sound Engineer',
  'Stage Technician',
  'Statistical Analyst',
  'Statistical Financial Analyst',
  'Structural Engineer',
  'Systems Software Developer',
  'Telecommunication Engineer',
  'Television Audio Engineer',
  'Timber Management Technician',
  'Tire Technician',
  'Tool Engineer',
  'Train Control Technician',
  'Train Engineer',
  'Tugboat Engineer',
  'Video Equipment Technician',
  'Waste Management Engineer',
  'Water Quality Analyst',
  'Water Treatment Technician',
  'Weather Analyst',
  'Web Applications Developer',
  'Web Content Developer',
  'Web Developer',
  'Actor / Actress',
  'Advertising Director',
  'Banquet Director',
  'Cafeteria Director',
  'Casting Director',
  'Childcare Center Director',
  'Choir Director',
  'Clinic Director',
  'Clinical Informatics Director',
  'Clinical Services Director',
  'Collections&Archives Director',
  'Compensation Director',
  'Cruise Director',
  'Data Operations Director',
  'Day Spa Director',
  'Disaster Response Director',
  'E-Commerce Director',
  'Employee Benefits Director',
  'Employee Development Director',
  'Family Service Center Director',
  'Financial Director',
  'Foundation Director',
  'Fundraising Director',
  'Funeral Home Director',
  'General Contractor',
  'Harvesting Contractor',
  'Health Services Director',
  'Hospice Director',
  'Hospital Director',
  'Hotel Director',
  'Information Systems Director',
  'IT Director',
  'IT Systems Director',
  'Labor Relations Director',
  'MIS Director',
  'Marionette Performer',
  'Marketing Director',
  'Medical Director',
  'Music Director',
  'Music Video Director',
  'Musician',
  'Nuclear Reactor Operator',
  'Nursing Service Director',
  'Orchestra Director',
  'Personnel Director',
  'Preschool Director',
  'Promotions Director',
  'Public Affairs Director',
  'Public Relations Director',
  'Public Safety Director',
  'Publicity Director',
  'Purchasing Director',
  'Radio & TV Technical Director',
  'Reactor Operator',
  'Records Management Director',
  'Religious Activities Director',
  'Religious Education Director',
  'Residential Director',
  'Residential Life Director',
  'Rodeo Performer',
  'Sales Director',
  'Sand Filler / Extractor',
  'Slot Operations Director',
  'Social Services Director',
  'Stunt Performer',
  'Television Newscast Director',
  'Television Program Director',
  'Therapy Director',
  'Tour Director',
  'Tractor Operator',
  'Welfare Director',
  'Wellness Director',
  'Youth Program Director',
  'Chief Sustainability Officer',
  'Conservationist',
  'Environmentalist',
  'Forest Ecologist',
  'Greenhouse Worker',
  'Greenskeeper',
  'Gynecologist',
  'Water Conservationist',
  'Wetlands Conservation',
  'Bar Host/Hostess',
  'Dining Room Host/Hostess',
  'Event Planner',
  'Fire Prevention Specialist',
  'Game Show Host',
  'Fire Prevention Inspector',
  'Radio Host',
  'Slot Host',
  'Talk Show Host',
  'Television Host',
  'Account Auditor',
  'Economist',
  'Financial / Cost Accountant',
  'Financial Auditor',
  'Fund Accountant',
  'Internal Auditor',
  'Investment Banker',
  'Payroll Auditor',
  'Public Accountant',
  'Social Economist',
  'Tax Accountant',
  'Baker',
  'Banquet Chef',
  'Camp Cook',
  'Clinical Dietitian',
  'Dietitian',
  'Fast Food Cook',
  'Kitchen Chef',
  'Mess Cook',
  'Pastry Chef',
  'Personal Chef',
  'Private Chef',
  'Public Health Dietitian',
  'School Cook',
  'Snack Bar Cook',
  'Sous Chef',
  'Border Patrol Officer',
  'Budget Officer',
  'Casino Surveillance Officer',
  'Chief Correctional Officer',
  'Chief Financial Officer',
  'Chief Operating Officer',
  'Compliance Officer',
  'Correction Officer',
  'Corrections Officer',
  'Court Officer',
  'Court Security Officer',
  'Deck Officer',
  'EEO Officer',
  'Escrow Officer',
  'Financial Officer',
  'Fire Officer',
  'Flight Deck Officer',
  'Fundraising Officer',
  'Hearing Officer',
  'Helicopter Officer',
  'Information Management Officer',
  'Intelligence Officer',
  'Job Placement Officer',
  'Landing Signal Officer',
  'Loan Officer',
  'Mayor',
  'Parking Enforcement Officer',
  'Parole Officer',
  'Patrol Officer',
  'Payday Loan Officer',
  'Police Officer',
  'Prison Officer',
  'Probation Officer',
  'Public Affairs Officer',
  'Public Relations Officer',
  'Real Estate Loan Officer',
  'Security Officer',
  'Tax Revenue Officer',
  'Wildlife Officer',
  'Acupuncture Doctor',
  'Addiction Therapist',
  'Brain Surgeon',
  'Cardiac/Cardiovascular Surgeon',
  'Chiropractic Doctor',
  'Clinical Nurse Specialist',
  'Couples Therapist',
  'Critical Care Doctor',
  'Dental Surgeon',
  'Drama Therapist',
  'Family Doctor',
  'Family Therapist',
  'Geriatric Physical Therapist',
  'Hearing Therapist',
  'Hypnotherapist',
  'jobal Therapist',
  'Marriage Counselor / Therapist',
  'Massage Therapist',
  'Music Therapist',
  'Neurological Surgeon',
  'Neurosurgeon',
  'Nurse Midwife',
  'Nurse Practitioner',
  'Nursery Day Care Worker',
  'Physical Therapist',
  'Physiotherapist',
  'Plastic Surgeon',
  'Practical Nurse',
  'Psychotherapist',
  'Pulmonary Doctor',
  'Pulmonary Physical Therapist',
  'Radiation Therapist',
  'Recreational Therapist',
  'Respiratory Therapist',
  'Speech Therapist',
  'Sports Medicine Doctor',
  'Sports Physical Therapist',
  'Vocational Nurse',
  'Computer Programmer',
  'Database Programmer',
  'IT Programmer',
  'Systems Programmer',
  'Agency Legal Counsel',
  'Attorney',
  'Attorney At Law',
  'Attorney General',
  'Circuit Court Judge',
  'City Attorney',
  'Civil Lawyer',
  'County Attorney',
  'County Court Judge',
  'Criminal Court Judge',
  'Defense Attorney',
  'Deputy Attorney General',
  'District Attorney',
  'District Court Judge',
  'Diving Judge',
  'Environmental Attorney',
  'Horse Show Judge',
  'Legal Aide',
  'Legal Counsel',
  'Legal Investigator',
  'Paralegal',
  'Paralegal Instructor',
  'Probate Judge',
  'Probate Lawyer',
  'Real Estate Attorney',
  'Tax Attorney',
  'Trial Attorney',
  'Trial Court Judge',
  'Trial Lawyer',
  'Tribal Judge',
  'Coach Tour Operator',
  'Expedition Guide',
  'Guide Dog Trainer',
  'Historical Site Guide',
  'Museum Guide',
  'Sightseeing Guide',
  'Tourist Guide',
  'Travel Expert',
  'Auto Cleaner',
  'Aviation Maintenance',
  'Battery Repairer',
  'Book Repairer',
  'Bus Cleaner / Washer',
  'Camera Repairer',
  'Cleaning & Maintenance Worker',
  'Conveyor Belt Repairer',
  'Dairy Equipment Repairer',
  'Electrical Maintenance Worker',
  'Lift/Escalator Service/Repair',
  'Equipment Cleaner',
  'Facilities Maintenance Worker',
  'Floor Cleaning / Maintenance',
  'General Maintenance Worker',
  'Guitar Repairer',
  'House Cleaner',
  'Janitor',
  'Jewelry Repairer',
  'Lawn Mower Repairer',
  'Machine Cleaner',
  'Maintenance Instructor',
  'Mobility Scooter Repairer',
  'Motorcycle Repairer',
  'Music Instrument Repairer',
  'Office Cleaner',
  'Power Transformer Repairer',
  'PBX Installer and Repairer',
  'Radio Repairer',
  'Rail Maintenance Worker',
  'Railroad Car Cleaner',
  'Railroad Car Repairer',
  'Repair Department Supervisor',
  'Sail Repairer',
  'Septic Tank Cleaner',
  'Sewer (Pipe) Cleaner',
  'Shoe Repairer',
  'Subway Car Repairer',
  'Swimming Pool Maintenance',
  'Telecomms Lines Install/Repair',
  'Telephone Lines Repairer',
  'Telescope Repairer',
  'Television Repairer',
  'Thermostat Repairer',
  'Track Repairer/ Service Worker',
  'Trail Maintenance Worker',
  'Truck Body Repairer',
  'Armature Assembler',
  'Automobile Assembler',
  'Automotive Machinist',
  'Camera Machinist',
  'CNC Machinist',
  'Electronic Assembler',
  'Eyeglass Assembler',
  'Furniture Assembler',
  'Generator Assembler',
  'Jet Engine Assembler',
  'Machine Assembler',
  'Machinist Supervisor',
  'Mining Production Geologist',
  'News Production Supervisor',
  'Precision Machinist',
  'Production Control',
  'Production Cost Estimator',
  'Production Machinist',
  'Production Scheduler',
  'Steam Turbine Assembler',
  'Switchboard Assembler / Wirer',
  'Theater Set Production Design',
  'Wood Working Assembler',
  'Advertising Agent',
  'Advertising Editor',
  'Auto Parts Salesperson',
  'Cattle Brander',
  'Chemical Sales Representative',
  'Department Store Salesperson',
  'Electronics Salesperson',
  'Insurance Sales Agent',
  'Insurance Sales Supervisor',
  'Land Sales Agent',
  'Marketing Consultant',
  'Marketing Forecaster',
  'Marketing Instructor',
  'Marketing Specialist',
  'Menswear Salesperson',
  'Mutual Fund Sales Agent',
  'Pest Control Service Sales',
  'Pharmaceutical Salesperson',
  'Real Estate Sales Supervisor',
  'Reservation (Sales) Agent',
  'Sales Route Driver',
  'Search Marketing Strategist',
  'Senior Management - Marketing',
  'Senior Management - Promotions',
  'Shoe Salesperson',
  'Telemarketing Representative',
  'Telemarketing Supervisor',
  'Telesales Representative',
  'Telesales Specialist',
  'Used Car Sales - Shop Owner',
  'Used Car Salesperson',
  'Journalist',
  'Media Relations Specialist',
  'Mediation',
  'News Anchor',
  'News Reporter',
  'Photojournalist',
  'Reporter',
  'Armed Forces - Medical',
  'Chief Medical Technologist',
  'Diagnostic Medical Sonographer',
  'Emergency Medical Services',
  'Medical (Research) Scientist',
  'Medical Claims Examiner',
  'Medical Dosimetrist',
  'Medical Transcriptionist',
  'Nuclear Medical Technologist',
  'Appeals Examiner',
  'Aviation Resource Management',
  'Bank Examiner',
  'Budget Examiner',
  'Cattle Examiner',
  'Compliance Examiner',
  "Driver's License Examiner",
  'Environmental Comms Specialist',
  'Environmental Control Admin',
  'Environmental Scientist',
  'Family Resource Specialist',
  'Forestry Laborer',
  'Geologist',
  'Health Claims Examiner',
  'Hearing Examiner',
  'Hydrogeologist',
  'Insurance Claims Examiner',
  'Land Title Examiner',
  'Lease Examiner',
  'Mineralogist',
  'Athletic Coach',
  'Baseball Coach',
  'Basketball Coach',
  'Boxing Coach',
  'Coach/Bus Driver',
  'Fitness Instructor / Trainer',
  'Football / Soccer Coach',
  'Ice Skating Coach',
  'Professional Athlete - Sports',
  'Race and Sports Book Writer',
  'Riding Coach',
  'Ski Coach',
  'Sports Complex Attendant',
  'Sports Editor',
  'Sports Nutritionist',
  'Tennis Coach',
  'ATM Servicer',
  'Auto Service Dispatcher',
  'Auto Service Station Attendant',
  'Cash Register Servicer',
  'Child & Family Services Worker',
  'Drycleaning Services',
  'Family Service Caseworker',
  'HVAC Services',
  'Hospital Food Service Worker',
  'Hotel Service Agent',
  'Lighting Fixture Installer',
  'Mobile Home Servicer',
  'Payroll Services',
  'Pizza Delivery Service Owner',
  'Postal Service Mail Processor',
  'Research & Development Service',
  'Service Forester',
  'Service Station Attendant',
  'Storage Facility Services',
  'Street Cleaning Services',
  'Tire Servicer',
  'Valet Services',
  'Veterans Services',
  'Well Service Worker',
  'Well Services Operator',
  'Body Shop Worker',
  'Cannabis store owner',
  'Convenience Store Owner',
  'Department Store Owner',
  'Liquor Store Owner',
  'Merchant Mariner',
  'Mystery Shopper',
  'Personal Shopper',
  'Retail Buyer',
  'Retail Store Owner',
  'Store Detective',
  'Behavioral Scientist',
  'Biochemist',
  'Biological Chemist',
  'Biologist',
  'Cancer Researcher',
  'Clinical Microbiologist',
  'Computational Theory Scientist',
  'Computer Scientist',
  'Crop Nutrition Scientist',
  'Dairy Scientist',
  'Dental Laboratory Worker',
  'Food Chemist',
  'Genetics Researcher',
  'Geoscientist',
  'Golf Course Laborer',
  'Labor Relations Consultant',
  'Labor Relations Representative',
  'Logging Laborer',
  'Marine Biologist',
  'Microbiologist',
  'Neuroscientist',
  'Optical Scientist',
  'Organic Chemist',
  'Oyster Boat Laborer',
  'Plant Scientist',
  'Plastics Scientist',
  'Political Researcher',
  'Poultry Scientist',
  'Recyclable Materials Collector',
  'Roofing Laborer',
  'Shrimp Pond Laborer',
  'Social Scientist',
  'Space Scientist',
  'Water Pollution Scientist',
  'Wharf Laborer',
  'Wildlife Biologist',
  'Armed Forces - Support',
  'Cryptologic Support Specialist',
  'Customer Contact Specialist',
  'Customer Support Agent',
  'Customer Support Specialist',
  'End-User Support Specialist',
  'IT Support Specialist',
  'Landing Support Specialist',
  'Network Diagnostic Support',
  'PC Support Specialist',
  'Personal Support Worker',
  'Addiction Counselor',
  'AIDS Counselor',
  'Anger Control Counselor',
  'Career Counselor',
  'Child and Family Counselor',
  'Credit Counselor',
  'Debt Management Counselor',
  'Financial Counselor',
  'HIV Counselor',
  'Relationship Counselor',
  'Student Advisor / Counselor',
  'Welfare Interviewer',
  'Welfare Worker',
  'Cardiopulmonary Technologist',
  'Cardiovascular Technologist',
  'Chief Technology Officer',
  'CT/CAT Technologist',
  'Computer Hardware Designer',
  'Food Technologist',
  'Health and Safety Technologist',
  'Nuclear Medicine Technologist',
  'Radiologic Technologist',
  'Software Applications Designer',
  'Software QA Specialist',
  'Surgical Technologist',
  'Systems Software Designer',
  'Systems Software Specialist',
  'Technical Editor',
  'Commodity Trader',
  'Equity Trader',
  'Foreign Exchange Trader',
  'Plumber',
  'Securities Trader',
  'Stock Trader',
  'Ambulance Driver-Paramedic',
  'Auto Carrier Driver',
  'Bus Driver',
  'Cab / Taxi Driver',
  'Cattle Driver',
  'Combine Driver / Operator',
  'Concrete Mixer Driver',
  'Garbage Truck Driver',
  'Hearse Driver',
  'Log Truck Driver',
  'Logistician',
  'Parcel Truck Driver',
  'Pedicab Driver',
  'Pizza Delivery Driver',
  'Rickshaw Driver',
  'School Bus Driver',
  'Septic Pump Truck Driver',
  'Shuttle Driver',
  'Tanker Driver',
  'Tram Driver',
  'Transport Aircrewman',
  'Truck Driver',
  'Airline Ticket Agent',
  'Apartment Rental Agent',
  "Author's Agent",
  'Booking Agent',
  'Car Rental Agent',
  'Cargo Agent',
  'City Planner',
  'Collection Agent',
  'Conference Planner',
  'Convention Planner',
  'Emergency Planner',
  'Estate Planner',
  'Financial Planner',
  'Freight Agent',
  'Information Systems Planner',
  'Insurance Agent',
  'Internal Revenue Agent',
  'Meeting Planner',
  'Modeling Agent',
  'Parole Agent',
  'Passenger Agent',
  'Pension Agent',
  'Personal Financial Planner',
  'Press Agent',
  'Publicity Agent',
  'Real Estate Agent',
  'Regional Planner',
  'Revenue Enforcement Agent',
  'Talent Agent',
  'Theatrical Agent',
  'Urban Planner',
  'Wedding Planner',
  'Compensations Claims Agent',
  'Inventory Taker',
  'Livestock Auctioneer',
  'Livestock Breeder',
  'Livestock Buyer',
  'Livestock Handler',
  'Stock Broker',
  'Stocker',
  'Air Traffic Control Specialist',
  'Aviation Medicine Specialist',
  'Aviation Operations Specialist',
  'Biodiesel Engine Specialist',
  'Armed Forces - Specialist',
  'Compensation Specialist',
  'Computer Help Desk Specialist',
  'Computer Security Specialist',
  'Computer Systems Consultant',
  'Computer Training Specialist',
  'Contact Center Specialist',
  'Data Analytics Specialist',
  'Data Integration Specialist',
  'Data Warehousing Specialist',
  'Display Specialist',
  'Employee Benefits Specialist',
  'Employee Placement Specialist',
  'Employee Relations Specialist',
  'Flight Security Specialist',
  'Health Education Specialist',
  'Hearing Instrument Specialist',
  'Industrial Relation Specialist',
  'Informatics Specialist',
  'IT Risk Specialist',
  'Job Training Specialist',
  'Lock Expert',
  'Management Consultant',
  'Market Research Specialist',
  'Motor Tune-Up Specialist',
  'Operations Specialist',
  'Pension Consultant',
  'Political Consultant',
  'Research Consultant',
  'Retirement Plan Specialist',
  'Sampling Expert',
  'Scalp Treatment Specialist',
  'Sterilization Specialist',
  'Tax Consultant',
  'Tax Specialist',
  'Timber Management Specialist',
  'Training Specialist',
  'Tree Specialist',
  'Web Content Specialist',
  'Occupations',
  '(Wireless) Internet Installer',
  '21 Dealer',
  '3D Animator',
  '411 Assistance Operator',
  '911 Dispatcher',
  '911 Operator',
  'Accompanist',
  'Accounts Collector',
  'Accounts Payable Supervisor',
  'Acrobat',
  'Acupuncturist',
  'Addiction Psychiatrist',
  'Administrative Court Justice',
  'Aerial Installer',
  'Agriculturist',
  'Air Cargo Ground Crew',
  'Air Conditioner Installer',
  'Air Control',
  'Air Traffic Control Operator',
  'Aircraft Inspector',
  'Airline Pilot',
  'Airline Reservationist',
  'Airplane Refueler',
  'Airport Baggage Screener',
  'Airport Security Screener',
  'Airport Tower Controller',
  'Algebra Tutor',
  'Algebraist',
  'Alternative Dispute Resolution',
  'Ambulance Attendant',
  'Ambulance Dispatcher',
  'Amusement Park Worker',
  'Anesthesiologist',
  'Anesthetist',
  'Animator',
  'Anthropologist',
  'Appeals Referee',
  'Applications Tester',
  'Arcade Worker',
  'Archaeologist',
  'Archivist',
  'Armed Guard',
  'Arson Investigator',
  'Art Conservator',
  'Artificial Limb Fitter',
  'Asphalt Blender/Paver/Roller',
  'Assembly (Line) Supervisor',
  'Assembly Line Machine Operator',
  'Assembly Line Tender',
  'Astronomer',
  'Astrophysicist',
  'Athletics Trainer',
  'Attending Anesthesiologist',
  'Au Pair',
  'Author',
  'Auto Body Worker',
  'Auto Glass Installer',
  'Auto Parker',
  'Auto Tire Worker',
  'Automobile Designer',
  'Automobile Detailer',
  'Automotive / Car dealer',
  'Baby Sitter',
  'Backhoe Operator',
  'Bacteriologist',
  'Bagger',
  'Bail Bondsman',
  'Ballet Dancer',
  'Ballet Soloist',
  'Ballet Trainer',
  'Balloon Pilot',
  'Bandmill Operator',
  'Bank Guard',
  'Bank Teller',
  'Banking Representative',
  'Banquet Set Up Person',
  'Barber',
  'Bareback Rider',
  'Barge Captain',
  'Barge Loader',
  'Barge Master',
  'Barn Worker',
  'Barrel Straightener',
  'Bartender',
  'Baseball Scout',
  'Baseball Umpire',
  'Beautician',
  'Bed and Breakfast Innkeeper',
  'Before or After School Care',
  'Bellstaff',
  'Bicycle Dealer',
  'Bicycle Designer',
  'Bicycle Messenger',
  'Bill Collector',
  'Billboard Poster',
  'Billing Representative',
  'Billing Supervisor',
  'Bindery Machine Operator',
  'Bindery Worker',
  'Biographer',
  'Biometrician',
  'Bird Trapper',
  'Blackjack Dealer',
  'Blackjack Pit Boss',
  'Blacktop-Paver Operator',
  'Blade Grader Operator',
  'Blanchard Grinder Operator',
  'Blast Hole Driller',
  'Blast Setter',
  'Blaster',
  'Blind Aide',
  'Block Layer',
  'Boardinghouse Keeper',
  'Boat Captain',
  'Boat Detailer',
  'Boat Pilot',
  'Bodyguard',
  'Bond Underwriter',
  'Bondsman',
  'Book Critic',
  'Book Editor',
  'Book Illustrator',
  'Book Reviewer',
  'Book Sorter',
  'Bookbinder',
  'Bookbinding Machine Operator',
  'Bookie',
  'Bookkeeper',
  'Border Guard',
  'Bouncer',
  'Box Fabricator',
  'Brace Maker',
  'Braille Proofreader',
  'Braille Transcriber',
  'Brewmaster',
  'Brick Carrier',
  'Brick Maker',
  'Brick Offbearer',
  'Brick Setter',
  'Brick Washer',
  'Bridge Inspector',
  'Bridge Ironworker',
  'Bridge Operator',
  'Bridge Tender',
  'Brief Writer',
  'Broadcast Producer',
  'Buffet Attendant',
  'Building Cleaning',
  'Building Inspector',
  'Bulldozer Operator',
  'Bus Dispatcher',
  'Bus Monitor',
  'Butler',
  'Cabinet Finisher',
  'Cable Splicer',
  'Cable Television Installer',
  'Caddy Master',
  'Cage Cashier',
  'Calligrapher',
  'Camera Operator',
  'Can Filler',
  'Can Sealer',
  'Armed Forces - Administration',
  'Canadian Armed Forces - Junior',
  'Armed Forces - Leadership',
  'Armed Forces - Operations',
  'Armed Forces - Training',
  'Candy Maker',
  'Cantor',
  'Canvas Cutter',
  'Car Alarm Installer',
  'Car Ferry Operator',
  'Car Refinisher',
  'Car Stereo Installer',
  'Car Wash Attendant',
  'Car Washer',
  'Card Table Attendant',
  'Cardiac/Vascular Sonographer',
  'Cardiologist',
  'Cargo Handler',
  'Cargo Router',
  'Carrot Harvester',
  'Cart Pusher',
  'Cartoonist',
  'Case Binder Operator',
  'Case Work Aide',
  'Cash Register Operator',
  'Casino Cage Cashier',
  'Casino Cashier',
  'Casino Dealer',
  'Casino Floor Runner',
  'Casino Games Dealer',
  'Casino Investigator',
  'Casino Slot Supervisor',
  'Casino Supervisor',
  'Cat Breeder',
  'Cattle Buyer',
  'Cattle Inspector',
  'Cattle Killer',
  'Ceiling Installer',
  'Cement Patcher',
  'CEO',
  'Ceramic Designer',
  'Ceramic Tile Installer',
  'Chaplain',
  'Charter Pilot',
  'Check Out Cashier',
  'Checkroom Attendant',
  'Cheese Maker',
  'Cheese Processor',
  'Chemical Plant Operator',
  'Chemical Process Equipment Op',
  'Chemical Processor',
  'Chemical Treatment Operator',
  'Chief Projectionist',
  'Chief Ship Steward',
  'Child Abuse Worker',
  'Child Care Worker',
  'Child Psychiatrist',
  'Childcare Attendant',
  'Childcare Worker',
  'Chimney Sweeper',
  'Chip Tuner',
  'Chiropodist',
  'Choir Member',
  'Chopper Feeder',
  'Chorus Master',
  'Church Organist',
  'Churn Driller',
  'Cigar Roller',
  'Circuit Board Drafter',
  'City Alderman',
  'City Bailiff',
  'City Council Member',
  'City Planning Aide',
  'City Surveyor',
  'Civil Drafter',
  'Classroom Aide',
  'Clay Worker',
  'Clerical Worker',
  'Climatologist',
  'Clinical Audiologist',
  'Clinical Epidemiologist',
  'Clinical Exercise Physiologist',
  'Clinical Nursing Instructor',
  'Clinical Pathologist',
  'Clinical Pharmacist',
  'Clinical Pharmacologist',
  'Clinical Psychiatrist',
  'Cloak Room Attendant',
  'Clock / Watch Maker',
  'Cloth Cutter / Dyer',
  'Clothes / Costumer Designer',
  'Clothes Ironer / Presser',
  'Clothes Model',
  'Clown',
  'Club Owner',
  'CNC Operator',
  'Coastal Tug Mate',
  'Coat Checker',
  'Coat Cutter',
  'Coat Maker',
  'Cocktail Server',
  'Cocktail Waitress',
  'Coin Box Collector',
  'Coke Loader',
  'Columnist',
  'Comic Illustrator',
  'Commentator',
  'Commercial Announcer',
  'Commercial Credit Reviewer',
  'Commercial Lender',
  'Commissioner Internal Revenue',
  'Commodities Broker',
  'Compliance Inspector',
  'Composer',
  'Computational Physicist',
  'Computer Console Operator',
  'Computer Language Coder',
  'Concert Pianist',
  'Concert Singer',
  'Concierge',
  'Concrete Batcher',
  'Concrete Finisher',
  'Concrete Floor Installer',
  'Concrete Pump Operator',
  'Concrete Smoother',
  'Conference Organizer',
  'Congressional Representative',
  'Conservator',
  'Constable',
  'Construction Estimator',
  'Construction Excavator',
  'Construction Inspector',
  'Construction Cost Estimator',
  'Construction Superintendent',
  'Construction Trench Digger',
  'Control Tower Operator',
  'Conveyor Belt Operator',
  'Conveyor Tender',
  'Convict Guard',
  'COO',
  'Copy Center Operator',
  'Copy Editor',
  'Copy Machine Operator',
  'Copy Reader',
  'Copywriter',
  'Core Stripper',
  'Corn Picker',
  'Corral Boss',
  'Correspondent',
  'Corsage Maker',
  'Cotton Broker',
  'Cotton Buyer',
  'Cotton Ginner/Grader/Picker',
  'Cotton Picker Operator',
  'Councilor',
  'Counsel',
  'County Bailiff',
  'County Commissioner',
  'County Surveyor',
  'Court Bailiff',
  'Court Interpreter',
  'Court Messenger',
  'Court Stenographer',
  'Court Transcriber',
  'Crab Picker',
  'Crabber',
  'Crane Crew Supervisor',
  'Crane Operator',
  'Craps Dealer',
  'Credit Authorizer',
  'Credit Checker',
  'Credit Investigator',
  'Credit Processor',
  'Credit Rating Checker',
  'Credit Report Checker',
  'Cremator',
  'Crematory Operator',
  'Crew Chief',
  'Crew Dispatcher',
  'Criminal Investigator',
  'Criminologist',
  'Crop Picker',
  'Crop Scout',
  'Crossing Guard',
  'Crusher Plant Operator',
  'Cryptographer',
  'Crystallographer',
  'CT/MRI Operator',
  'Curbstone Setter',
  'Custodial Worker',
  'Customs Appraiser',
  'Dairy Bacteriologist',
  'Dairy Husbandry Worker',
  'Damage Appraiser',
  'Dancer',
  'Data Center Operator',
  'Data Entry Supervisor',
  'Database Security Admin',
  'Day Care Worker',
  'Daycare Aide',
  'Daycare Provider',
  'Deaf Interpreter',
  'Deboner',
  'Debt Collector',
  'Deck Hand',
  'Decontamination Worker',
  'Decorator',
  'Demographer',
  'Dental Aide',
  'Dental Hygienist',
  'Dentist',
  'Deputy Bailiff',
  'Deputy Chief Counsel',
  'Deputy Marshal',
  'Deputy Sheriff',
  'Dermatopathologist',
  'Detective',
  'Detention Deputy',
  'Diagnostic Radiologist',
  'Diamond Grader',
  'Diamond Polisher',
  'Diamond Setter',
  'Diesel Engine Fitter',
  'Digital Archivist',
  'Digital Cartographer',
  'Digital Designer',
  'Digital Press Operator',
  'Disc Recordist',
  'Dish Room Worker',
  'Dishwasher',
  'Dispensing Audiologist',
  'Dispensing Optician',
  'Display Decorator',
  'Display Designer',
  'DJ',
  'Dock Loader',
  'Docking Pilot',
  'Documentation Writer',
  'Dog Bather',
  'Dog Beautician',
  'Dog Breeder',
  'Dog Catcher',
  'Dog Groomer',
  'Dog Handler',
  'Dog Sitter',
  'Dog Trainer',
  'Doll Maker',
  'Dough Maker, Scaler and Mixer',
  'Dramatic Reader',
  'Drawbench Operator',
  'Drill Operator',
  'Drill Press Operator for Metal',
  'Drilling Rig Operator',
  'Driving Instructor',
  'Dryer Feeder',
  'Dynamiter',
  'Eating Disorder Psychologists',
  'Econometrician',
  'Editor',
  'Editorial Cartoonist',
  'Education Minister',
  'Educational Audiologist',
  'Elderly Companion',
  'Electron Beam Welder Setter',
  'Electronic Instrument Testing',
  'Electronic Publisher',
  'Elevator / Escalator Installer',
  'Elevator Inspector',
  'Embalmer',
  'Emergency Management',
  'Emergency Operator',
  'Encephalographer',
  'End Loader Operator',
  'Engine Designer',
  'Engraver',
  'Enroute Controller',
  'Epidemiologist',
  'EEO Investigator',
  'EEO Representative',
  'Erecting Crane Operator',
  'Estate Appraiser',
  'Estate Conservator',
  'Ethnologist',
  'Etymologist',
  'Excavating Supervisor',
  'Exchange Teller',
  'Exterminator',
  'Eyeglass Fitter',
  'Eyeglass Lens Cutter',
  'Eyeglass Maker',
  'Fabric Cutter',
  'Family Practitioner',
  'Family Sociologist',
  'Fare Collector',
  'Fashion Illustrator',
  'Fashion Model',
  'Ferris Wheel Operator',
  'Ferry Boat Captain',
  'Ferry Captain',
  'Ferry Operator',
  'File Keeper',
  'Film Critic',
  'Film Editor',
  'Film Maker',
  'Film Process Operator',
  'Film Processor',
  'Film Projector Operator',
  'Fire Alarm Installer',
  'Fire Claims Adjuster',
  'Fire Dispatcher',
  'Fire Engine Pump Operator',
  'Fire Equipment Operator',
  'Fire Extinguisher Installer',
  'Fire Hazard Inspector',
  'Fire Investigator',
  'Fire Marshal',
  'Fire Ranger',
  'Fire Safety Inspector',
  'Fire Sprinkler Installer',
  'Firefighter',
  'First Mate',
  'Fish Culturist',
  'Fish Cutter',
  'Fish Filleter',
  'Fish Fryer',
  'Fish Smoker',
  'Fish Warden',
  'Fishing Boat Captain',
  'Flight Attendant',
  'Flight Communications Operator',
  'Flight Crew Ordnanceman',
  'Flight Crew Scheduler',
  'Flight Instructor',
  'Flight Paramedic',
  'Flight Steward',
  'Floor Installer / Layer',
  'Florist',
  'Flower Arranger',
  'Flower Picker',
  'Food Counter Worker',
  'Food Preparer',
  'Foot Orthopedist',
  'Foreign Banknote Teller',
  'Foreign Correspondent',
  'Forensic Psychiatrist',
  'Forester',
  'Forewoman /Foreman',
  'Forklift Operator',
  'Fortune Teller',
  'Foster Care Worker',
  'Freight Broker',
  'Freight Conductor',
  'Freight Handler',
  'Freight Inspector',
  'Front Desk Attendant',
  'Front-End Loader Operator',
  'Fruit / Vegetable Picker',
  'Fruit / Vegetable Sorter',
  'Fumigator',
  'Furniture Designer',
  'Game Warden',
  'Garbage Collector',
  'Gardener',
  'Genealogist',
  'General Counsel',
  'General Internal Medicine Doc',
  'General Internist',
  'General Practitioner',
  'Geographer',
  'Geophysicist',
  'Geriatric Personal Care',
  'Geriatric Psychiatrist',
  'Gift Wrapper',
  'Glass Blower',
  'Glass Decorator',
  'Glass Installer',
  'Glass Processing',
  'Glue Line Operator',
  'Goat /Sheep Herder',
  'Go-Go Dancer',
  'Gold Buyer',
  'Goldsmith',
  'Golf Caddy',
  'Governor / Governess',
  'Grader Operator',
  'Grain Buyer',
  'Grain Elevator Operator',
  'Grain Roaster',
  'Grain Sampler',
  'Granite Setter',
  'Graphic Designer',
  'Grave Digger',
  'Guardrail Installer',
  'Gunsmith',
  'Hair and Makeup Designer',
  'Hairdresser / Hair Stylist',
  'Handbook / Instructions Writer',
  'Harbor Boat Pilot',
  'Harbor Pilot',
  'Harbor Tug Captain',
  'Harvest Worker',
  'Hat Designer',
  'Hatchery Worker',
  'Hay Baler',
  'Hay Stacker',
  'Hazard Waste Handler',
  'Hazardous Waste Management',
  'Head Waiter / Waitress',
  'Health Advocate',
  'Health and Safety Inspector',
  'Health Insurance Adjuster',
  'Hearing Aid Fitter',
  'Heavy Duty Custodian',
  'Hedge / Tree Trimmer',
  'Helicopter Crew Member',
  'Helicopter Pilot',
  'Help Desk Representative',
  'Herbicide Sprayer',
  'High School Principal',
  'Highway Inspector',
  'Highway Patrol',
  'Highway Worker',
  'Historiographer',
  'Hockey Scout',
  'Hog Buyer',
  'Home Appliance Installer',
  'Home Inspector',
  'Homeopathic Practitioner',
  'Homicide Detective',
  'Horse Breeder',
  'Horse Trainer',
  'Horticulture Instructor',
  'Hospital Aide',
  'Hospital Attendant',
  'Hospital Chaplain',
  'Hot Dog Vender',
  'Hotel Dining Room Cashier',
  'Hotel Baggage Handler',
  'Hotel Waiter',
  'House Parent',
  'House Sitter',
  'House Wirer',
  'Hunter',
  'Hydraulic Press-In Operator',
  'Hydroelectric Plant Operator',
  'Hydrometer Calibrator',
  'Hygienist',
  'Ice Cream Maker',
  'Ice Cream Vendor',
  'Ice Rink Attendant',
  'Impersonator',
  'Income Tax Adjuster',
  'Income Tax Advisor',
  'Income Tax Preparer',
  'Index Editor',
  'Industrial Hygienist',
  'Industrial Plant Custodian',
  'Information Systems Security',
  'Innkeeper',
  'Inseminator',
  'Instrumentalist',
  'Insulation Installer',
  'Insurance (Under-)Writer',
  'Insurance Actuary',
  'Insurance Adjuster',
  'Insurance Broker',
  'Insurance Collector',
  'Intelligence, Operations',
  'Interior Decorator',
  'Interior Designer',
  'International Student Counsel',
  'Internist',
  'Interpreter',
  'Investigator',
  'Jeweler',
  'Jewelry Grinder',
  'Jewelry Polisher',
  'Jewelsmith',
  'Job Estimator',
  'Job Recruiter',
  'Juggler',
  'Jurist',
  'Keno Runner',
  'Keno Writer',
  'Key Maker',
  'Kitchen and Bath Designer',
  'Kitchen Steward',
  'Kitchen Supervisor',
  'Knife Grinder',
  'Land Surveyor',
  'Language Translator',
  'Language Tutor',
  'Laundry Attendant',
  'Laundry Equipment Operator',
  'Laundry Operator',
  'Laundry Sorter',
  'Laundry Worker',
  'Lawn Caretaker',
  'Lawn Mower',
  'Leaflet Distributor',
  'Leather Worker',
  'Legislator',
  'Lens Grinder and Polisher',
  'Lens Mounter',
  'License Inspector',
  'Lifeguard',
  'Light Rail Operator',
  'Lighthouse Keeper',
  'Linguist',
  'Loader Operator',
  'Loan Interviewer',
  'Loan Processor',
  'Loan Reviewer',
  'Loan Teller',
  'Lobbyist',
  'Local Area Network Admin',
  'Lock Fitter / Setter',
  'Locker Room Attendant',
  'Locker Room Supervisor',
  'Locksmith',
  'Locomotive Inspector',
  'Locomotive Switch Operator',
  'Log Processing',
  'Log Stacker Operator',
  'Logging Crew Supervisor',
  'Logging Excavator Operator',
  'Logging Shovel Operator',
  'Luggage Attendant',
  'Lumberjack',
  'Lyricist',
  'Machine Welder',
  'Machinery Appraiser',
  'Machinery Dismantler',
  'Maestro',
  'Magician',
  'Maid / Housekeeping Staff',
  'Maid Supervisor',
  'Mail Deliverer',
  'Management Psychologist',
  'Manufacturing Machine Operator',
  'Manuscript Editor',
  'Map Maker',
  'Mapper',
  'Marine Diver',
  'Marine Drafter',
  'Market Research Interviewer',
  'Massage Practitioner',
  'Masseur / Masseuse',
  'Material Expediter',
  'Material Handler',
  'Mathematical Physicist',
  'Mathematical Statistician',
  'Meat and Poultry Inspector',
  'Meat Cutter',
  'Meat Packager',
  'Meat Processor',
  'Member of Congress',
  'Merchandise Buyer',
  'Merchandise Displayer',
  'Metal Caster',
  'Metal Processing',
  'Metallographer',
  'Metallurgist',
  'Meteorologist',
  'Meter Installer',
  'Meter Maid',
  'Meter Reader',
  'Metrologist',
  'Milk Processor',
  'Mill Recorder',
  'Mining Backhoe Operator',
  'Mining Bulldozer Operator',
  'Mining End Loader Operator',
  'Mining Excavator',
  'Mining Machine Operator',
  'Mining Payloader Operator',
  'Mining Shovel Operator',
  'Minister',
  'Missionary',
  'Molding Plasterer',
  'Molecular Physicist',
  'Mortar Mixer',
  'Mortgage Loan Processor',
  'Mortgage Processor',
  'Mortician',
  'Motorcycle Dealer',
  'Motorcycle Deliverer',
  'Motorcycle Police',
  'Mounted Police',
  'Movie Critic',
  'Movie Editor',
  'Movie Producer',
  'Movie Projectionist',
  'Museum Archivist',
  'Museum Docent',
  'Music Video Producer',
  'Mutuel Teller',
  'Nail Salon Owner',
  'Nanny',
  'Network Designer',
  'Neuropathologist',
  'Neuropsychiatrist',
  'Neuropsychologist',
  'Newspaper Carrier',
  'Newspaper Correspondent',
  'Newspaper Deliverer',
  'Newstand Vendor',
  'Notary Public',
  'Novelist',
  'Nuclear Control Room Operator',
  'Nuclear Physicist',
  'Nuclear Station Operator',
  'Nun',
  'Nursing Aide',
  'Nutritionist',
  'Office Messenger',
  'Offset Press Operator',
  'Ombudsman',
  'Oncologist',
  'Opera Singer',
  'Optical Dispenser',
  'Optician',
  'Oral Hygienist',
  'Orchard Hand',
  'Orchard Sprayer',
  'Orchard Worker',
  'Orchestra Conductor',
  'Orchestrator',
  'Organ Installer',
  'Organ Tuner',
  'Organist',
  'Ornamental Worker',
  'Ornithologist',
  'Orthodontist',
  'Orthopedic Podiatrist',
  'Orthotic Fitter',
  'Orthotics Fitter',
  'Orthotist',
  'Outbound Telemarketer',
  'Oyster Buyer',
  'Oyster Shucker',
  'Oyster Sorter',
  'Package Handler',
  'Packer',
  'Packing Line Operator',
  'Packing Machine Can Feeder',
  'Paediatrician',
  'Paleontologist',
  'Paper Cutter',
  'Paper Machine Operator',
  'Paper Slitter',
  'Parachutist',
  'Parcel Post Carrier',
  'Park Police',
  'Parking Meter Attendant',
  'Pastor',
  'Pastoral Worker',
  'Pathologist',
  'Pawnbroker',
  'Payroll Bookkeeper',
  'Payroll Supervisor',
  'PBX Operator',
  'Peanut Butter Maker',
  'Peddler',
  'Pediatrician',
  'Pedicurist',
  'Penologist',
  'Pension Adviser',
  'Personal Investment Adviser',
  'Personal Property Assessor',
  'Personal Trainer',
  'Personnel Recruiter',
  'Pest Controller',
  'Pesticide Applicator',
  'Pharmacist',
  'Pharmacologist',
  'Philologist',
  'Photographer',
  "Photographer's Model",
  'Physical Anthropologist',
  'Physical Geographer',
  'Physicist',
  'Phytopathologist',
  'Pianist',
  'Picking Crew',
  'Pickle House Operator',
  'Pickle Maker',
  'Pile Hammer Operator',
  'Pipe Fitter/Insulator/Layer',
  'Pipe Straightener',
  'Pipe Welder',
  'Pit Boss',
  'Plant Chief',
  'Plant Etiologist',
  'Plant Physiologist',
  'Plant Sprayer',
  'Planting Supervisor',
  'Plaster Mixer',
  'Plaster Tender',
  'Plasterer',
  'Plate Mounter',
  'Plating Machine Operator',
  'Playground Aide',
  'Playwright',
  'Plumbing Inspector',
  'Poet',
  'Police Detective',
  'Police Dispatcher',
  'Police Lieutenant',
  'Police Radio Dispatcher',
  'Polisher',
  'Political Anthropologist',
  'Political Geographer',
  'Political Science Research',
  'Port Captain',
  'Porter',
  'Portrait Photographer',
  'Postal Mail Carrier',
  'Postmaster',
  'Poultry Pathologist',
  'Poultry Processing',
  'Power Lineworker',
  'Powerhouse Operator',
  'Predator Control Trapper',
  'Press Writer',
  'Priest',
  'Printing Machine Operator',
  'Printing Worker',
  'Prison Guard',
  'Private Detective',
  'Private Investigator',
  'Private Watchman',
  'Privately Owned ATM',
  'Procedural Dermatologist',
  'Processing Archivist',
  'Produce Department',
  'Product Development',
  'Professional Ergonomist',
  'Program Writer',
  'Promotor(a)',
  'Prompter',
  'Proofreader',
  'Property Damage Claim Adjustor',
  'Prosecutor',
  'Prosthetist/Orthotist',
  'Pruner',
  'Psychological Operations',
  'Psychologist',
  'Public Address Announcer',
  'Public Defender',
  'PR Representative',
  'Public Safety Dispatcher',
  'Public Safety Telecommunicator',
  'Public Works Inspector',
  'Publications Editor',
  'Publicist',
  'Publicity Writer',
  'Pulmonologist',
  'Quality (Control) Inspector',
  'Quality Inspector',
  'Quilter',
  'Rabbi',
  'Radio Astronomer',
  'Radio Disc Jockey',
  'Radio Operator',
  'Radio Producer',
  'Radio Time Buyer',
  'Rail Car Loader',
  'Rail Loader',
  'Railroad Brake Operator',
  'Railroad Car Inspector',
  'Railroad Inspector',
  'Railway Equipment Operator',
  'Railway Switch Operator',
  'Rake Operator',
  'Ranch Hand',
  'Rapper',
  'Reading Tutor',
  'Real Estate Appraiser',
  'Real Estate Assessor',
  'Real Estate Broker',
  'Real Property Evaluator',
  'Receiving Teller',
  'Recruiter',
  'Reforestation Worker',
  'Refrigerating Machine Operator',
  'Refrigeration Insulator',
  'Refrigeration Operator',
  'Refrigeration System Installer',
  'Refuse Collector',
  'Rehabilitation Aide',
  'Rehabilitation Psychologist',
  'Religious Education Coordinate',
  'Repossessor',
  'Restaurant Owner',
  'Restaurant Waiter',
  'Revenue Collector',
  'Reverend',
  'Rheumatologist',
  'Rig Supervisor',
  'Rigger',
  'Rigging Slinger',
  'Ringmaster',
  'Road Grader',
  'Road Patcher',
  'Road Sign Installer',
  'Rock Drill Operator',
  'Rock Dust Sprayer',
  'Rock Duster',
  'Rodent Exterminator',
  'Roofer',
  'Roulette Dealer',
  'Saddle and Harness Maker',
  'Safe and Vault Installer',
  'Sailboat Captain',
  'Sailor',
  'Salad Maker',
  'Sample Checker',
  'Sand Molder',
  'Sandstone Splitter',
  'Sandwich Maker',
  'Satellite Comms Operator',
  'Satellite Dish Installer',
  'Savings Teller',
  'Saw Operator',
  'Sawyer',
  'Scale Adjuster',
  'Scale Operator',
  'School Bus Dispatcher',
  'School Bus Operator',
  'School Custodian',
  'School Photographer',
  'School Principal',
  'School Superintendent',
  'School Traffic Guard',
  'Scientific Illustrator',
  'Scientific Publications Editor',
  'Scrap Crane Operator',
  'Scrap Metal Collector',
  'Scraper Operator',
  'Screen Writer',
  'Script Writer',
  'Scuba Diver',
  'Seaman',
  'Seaweed Harvester',
  'Securities Teller',
  'Security Alarm Installer',
  'Security Guard Supervisor',
  'Seed Sorter',
  'Seismologist',
  'Senator',
  'Sensor Operator',
  'Set Decorator',
  'Sewage Plant Operator',
  'Shearer Operator',
  'Sheep Shearer',
  'Ship Purser',
  'Ship Steward',
  'Ship Unloader',
  'Shipfitter',
  'Shoemaker',
  'Short Story Writer',
  'Shovel Operator',
  'Show Floor Decorator',
  'Shrimp Peeler',
  'Shrimp Picker',
  'Signalman',
  'Silver Solderer',
  'Silversmith',
  'Ski Lift Attendant',
  'Ski Lift Operator',
  'Ski Patrol',
  'Slaughterer',
  'Slot Attendant',
  'Snack Bar Attendant',
  'Snack Bar Cashier',
  'Social Psychologist',
  'Sociologist',
  'Song Lyricist',
  'Songwriter',
  'Sound Cutter',
  'Sound Designer',
  'Sound Editor',
  'Souvenir Street Vendor',
  'Spa Owner',
  'Space Operations',
  'Speech Clinician',
  'Speech Pathologist',
  'Speedboat Operator',
  'Spotlight Operator',
  'Spraying Machine Operator',
  'Stacker Operator',
  'Staff Psychiatrist',
  'Stage Designer',
  'State Trooper',
  'Statement Processor',
  'Statistical Typist',
  'Statistician',
  'Steam and Power Panel Operator',
  'Steam Plant Control Room Op',
  'Steam Shovel Operating',
  'Steam Shovel Operator',
  'Steamfitter',
  'Steel Fabricator',
  'Steel Fitter',
  'Steel Pourer',
  'Steel Rod Buster',
  'Steel Roller',
  'Steel Tier',
  'Stone Carver',
  'Stone Layer',
  'Story Teller',
  'Structural Drafter',
  'Structural Steel Erector',
  'Stucco Worker',
  'Studio Model',
  'Submarine Diver',
  'Substation Operator',
  'Sugar Presser',
  'Suit Maker',
  'Surgical Appliance Fitter',
  'Surgical Oncologist',
  'Surgical Orderly',
  'Survey Interviewer',
  'Survey Methodologist',
  'Survey Questionnaire Designer',
  'Survey Statistician',
  'Swimming Pool Installer',
  'Table Games Dealer',
  'Table Games Supervisor',
  'Tailor',
  'Tap Dancer',
  'Tape Editor',
  'Taproom Attendant',
  'Tavern Owner',
  'Tax Investigator',
  'Tax Preparer',
  'Taxi Dispatcher',
  'Telemarketer',
  'Telephone Interviewer',
  'Telephone Lineworker',
  'Telephone Switchboard Operator',
  'Television Camera Operator',
  'Television Installer',
  'Television News Producer',
  'Television News Video Editor',
  'Television Producer',
  'Television Writer',
  'Tenor',
  'Termite Treater',
  'Terrazzo Worker',
  'Tester',
  'Textile - Machine Operator',
  'Textile Designer',
  'Theater Company Producer',
  'Theater Usher',
  'Theatrical Wardrobe Dresser',
  'Ticket Attendant',
  'Ticket Collector',
  'Tile Designer',
  'Tile Installer',
  'Tile Setter',
  'Timber Cutter',
  'Timber Hand',
  'Timber Harvester Operator',
  'Timekeeper',
  'Tobacco Buyer',
  'Tobacco Drier Operator',
  'Toll Booth Operator',
  'Toll Collector',
  'Tool Designer',
  'Tool Grinder',
  'Tool Maker',
  'Tool Sharpener / Straightener',
  'Topographer',
  'Tow Boat Captain',
  'Tow Truck Dispatcher',
  'Tow Truck Operator',
  'Tower Loader Operator',
  'Toxicologist',
  'Toy Designer',
  'Track Layer / Maintainer',
  'Trail Construction Worker',
  'Train Attendant',
  'Train Brake Operator',
  'Train Caller / Announcer',
  'Train Conductor',
  'Train Dispatcher',
  'Tram Operator',
  'Transcription Typist',
  'Transit Police',
  'Translator',
  'Trash Collector',
  'Tree Pruner',
  'Tree Trimmer',
  'Tree-Shear Operator',
  'Trenching Machine Operator',
  'Tribal Council Member',
  'Trimming Operator',
  'Trolley Car Operator',
  'Truck Dispatcher',
  'Truck Operator',
  'Truck Washer',
  'Tug Boat Captain',
  'Tugboat Captain',
  'Tugboat Mate',
  'Tugboat Operator',
  'Tumbler',
  'Twister Operator',
  'Type Setter',
  'Typist',
  'Underwater Welder',
  'Union Representative',
  'University Dean',
  'University Department Chair',
  'University President',
  'University Registrar',
  'Upholsterer',
  'Urologist',
  'Usher',
  'Utilities Ground Worker',
  'Van Loader',
  'Vault Teller',
  'Vehicle Inspector',
  'Vending Machine Operator',
  'Video Camera Operator',
  'Video Control Operator',
  'Video Producer',
  'Videographer',
  'Vineyard Tender',
  'Vinyl Installer',
  'Violinist',
  'Violist',
  'Virologist',
  'Visual Designer',
  'Visual Merchandising',
  'Vocalist',
  'Vocational Adviser',
  'Volcanologist',
  'Wall Covering Installer',
  'Wallpaper Hanger',
  'Wardrobe Attendant',
  'Washroom Attendant',
  'Waste Collector',
  'Waste Treatment Operator',
  'Wastewater Operator',
  'Water Plant Operator',
  'Water Pump Installer',
  'Water Taxi Operator',
  'Waterproofer',
  'Wax Pattern Coater',
  'Weather Forecaster',
  'Weatherman',
  'Web Press Operator',
  'Wedding Photographer',
  'Weed Sprayer',
  'Weighing Station Operator',
  'Welder Fitter',
  'Welding Instructor',
  'Welding Machine Operator',
  'Welding Robot Operator',
  'Wellness Studio/Ressort Owner',
  'Wheat Inspector',
  'Wholesale Buyer',
  'Wholesale Diamond Broker',
  'Wide Area Network Admin',
  'Wig Stylist',
  'Wildlife and Game Protector',
  'Winch Operator',
  'Wine Steward',
  'Winemaker',
  'Wire Walker',
  'Wire Welder',
  'Wood - Machine Operator',
  'Wood Carver',
  'Wood Cutter',
  'Wood Dealer',
  'Wood Model Maker',
  'Woodyard Crane Operator',
  'Yard worker',
  'Yeast Maker',
  'Privately Owned  ATM',
  'Pawn Shop Clerk',
  'New Car Salesperson',
  'City Treasurer',
  'Campaign Fundraiser',
  'Cafeteria Owner',
  'Body Shop Owner',
  'Beauty Salon Owner',
  'Automotive Salesperson',
  'Auctioneer',
  'Art Handler',
];

export interface OccupationIndustryOption {
  text: string;
  occupation: string;
  industry: string;
}

export const CountryList = [
  {
    code: 'CA',
    label: 'Canada',
    phone: '1',
    suggested: true,
  },
  {
    code: 'US',
    label: 'United States',
    phone: '1',
    suggested: true,
  },
  { code: 'GB', label: 'United Kingdom', phone: '44' },
  {
    code: 'FR',
    label: 'France',
    phone: '33',
    suggested: true,
  },
  {
    code: 'DE',
    label: 'Germany',
    phone: '49',
    suggested: true,
  },
  { code: 'IT', label: 'Italy', phone: '39' },
  { code: 'AT', label: 'Austria', phone: '43' },
  {
    code: 'AU',
    label: 'Australia',
    phone: '61',
    suggested: true,
  },
  // Rest of the world
  { code: 'AD', label: 'Andorra', phone: '376' },
  {
    code: 'AE',
    label: 'United Arab Emirates',
    phone: '971',
  },
  { code: 'AF', label: 'Afghanistan', phone: '93' },
  {
    code: 'AG',
    label: 'Antigua and Barbuda',
    phone: '1-268',
  },
  { code: 'AI', label: 'Anguilla', phone: '1-264' },
  { code: 'AL', label: 'Albania', phone: '355' },
  { code: 'AM', label: 'Armenia', phone: '374' },
  { code: 'AO', label: 'Angola', phone: '244' },
  { code: 'AQ', label: 'Antarctica', phone: '672' },
  { code: 'AR', label: 'Argentina', phone: '54' },
  { code: 'AS', label: 'American Samoa', phone: '1-684' },
  { code: 'AW', label: 'Aruba', phone: '297' },
  { code: 'AX', label: 'Alland Islands', phone: '358' },
  { code: 'AZ', label: 'Azerbaijan', phone: '994' },
  {
    code: 'BA',
    label: 'Bosnia and Herzegovina',
    phone: '387',
  },
  { code: 'BB', label: 'Barbados', phone: '1-246' },
  { code: 'BD', label: 'Bangladesh', phone: '880' },
  { code: 'BE', label: 'Belgium', phone: '32' },
  { code: 'BF', label: 'Burkina Faso', phone: '226' },
  { code: 'BG', label: 'Bulgaria', phone: '359' },
  { code: 'BH', label: 'Bahrain', phone: '973' },
  { code: 'BI', label: 'Burundi', phone: '257' },
  { code: 'BJ', label: 'Benin', phone: '229' },
  { code: 'BL', label: 'Saint Barthelemy', phone: '590' },
  { code: 'BM', label: 'Bermuda', phone: '1-441' },
  { code: 'BN', label: 'Brunei Darussalam', phone: '673' },
  { code: 'BO', label: 'Bolivia', phone: '591' },
  { code: 'BR', label: 'Brazil', phone: '55' },
  { code: 'BS', label: 'Bahamas', phone: '1-242' },
  { code: 'BT', label: 'Bhutan', phone: '975' },
  { code: 'BV', label: 'Bouvet Island', phone: '47' },
  { code: 'BW', label: 'Botswana', phone: '267' },
  { code: 'BY', label: 'Belarus', phone: '375' },
  { code: 'BZ', label: 'Belize', phone: '501' },
  {
    code: 'CC',
    label: 'Cocos (Keeling) Islands',
    phone: '61',
  },
  {
    code: 'CD',
    label: 'Congo, Democratic Republic of the',
    phone: '243',
  },
  {
    code: 'CF',
    label: 'Central African Republic',
    phone: '236',
  },
  {
    code: 'CG',
    label: 'Congo, Republic of the',
    phone: '242',
  },
  { code: 'CH', label: 'Switzerland', phone: '41' },
  // eslint-disable-next-line prettier/prettier
  { code: 'CI', label: 'Cote d\'Ivoire', phone: '225' },
  { code: 'CK', label: 'Cook Islands', phone: '682' },
  { code: 'CL', label: 'Chile', phone: '56' },
  { code: 'CM', label: 'Cameroon', phone: '237' },
  { code: 'CN', label: 'China', phone: '86' },
  { code: 'CO', label: 'Colombia', phone: '57' },
  { code: 'CR', label: 'Costa Rica', phone: '506' },
  { code: 'CU', label: 'Cuba', phone: '53' },
  { code: 'CV', label: 'Cape Verde', phone: '238' },
  { code: 'CW', label: 'Curacao', phone: '599' },
  { code: 'CX', label: 'Christmas Island', phone: '61' },
  { code: 'CY', label: 'Cyprus', phone: '357' },
  { code: 'CZ', label: 'Czech Republic', phone: '420' },
  { code: 'DJ', label: 'Djibouti', phone: '253' },
  { code: 'DK', label: 'Denmark', phone: '45' },
  { code: 'DM', label: 'Dominica', phone: '1-767' },
  {
    code: 'DO',
    label: 'Dominican Republic',
    phone: '1-809',
  },
  { code: 'DZ', label: 'Algeria', phone: '213' },
  { code: 'EC', label: 'Ecuador', phone: '593' },
  { code: 'EE', label: 'Estonia', phone: '372' },
  { code: 'EG', label: 'Egypt', phone: '20' },
  { code: 'EH', label: 'Western Sahara', phone: '212' },
  { code: 'ER', label: 'Eritrea', phone: '291' },
  { code: 'ES', label: 'Spain', phone: '34' },
  { code: 'ET', label: 'Ethiopia', phone: '251' },
  { code: 'FI', label: 'Finland', phone: '358' },
  { code: 'FJ', label: 'Fiji', phone: '679' },
  {
    code: 'FK',
    label: 'Falkland Islands (Malvinas)',
    phone: '500',
  },
  {
    code: 'FM',
    label: 'Micronesia, Federated States of',
    phone: '691',
  },
  { code: 'FO', label: 'Faroe Islands', phone: '298' },
  { code: 'GA', label: 'Gabon', phone: '241' },
  { code: 'GD', label: 'Grenada', phone: '1-473' },
  { code: 'GE', label: 'Georgia', phone: '995' },
  { code: 'GF', label: 'French Guiana', phone: '594' },
  { code: 'GG', label: 'Guernsey', phone: '44' },
  { code: 'GH', label: 'Ghana', phone: '233' },
  { code: 'GI', label: 'Gibraltar', phone: '350' },
  { code: 'GL', label: 'Greenland', phone: '299' },
  { code: 'GM', label: 'Gambia', phone: '220' },
  { code: 'GN', label: 'Guinea', phone: '224' },
  { code: 'GP', label: 'Guadeloupe', phone: '590' },
  { code: 'GQ', label: 'Equatorial Guinea', phone: '240' },
  { code: 'GR', label: 'Greece', phone: '30' },
  {
    code: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
    phone: '500',
  },
  { code: 'GT', label: 'Guatemala', phone: '502' },
  { code: 'GU', label: 'Guam', phone: '1-671' },
  { code: 'GW', label: 'Guinea-Bissau', phone: '245' },
  { code: 'GY', label: 'Guyana', phone: '592' },
  { code: 'HK', label: 'Hong Kong', phone: '852' },
  {
    code: 'HM',
    label: 'Heard Island and McDonald Islands',
    phone: '672',
  },
  { code: 'HN', label: 'Honduras', phone: '504' },
  { code: 'HR', label: 'Croatia', phone: '385' },
  { code: 'HT', label: 'Haiti', phone: '509' },
  { code: 'HU', label: 'Hungary', phone: '36' },
  { code: 'ID', label: 'Indonesia', phone: '62' },
  { code: 'IE', label: 'Ireland', phone: '353' },
  { code: 'IL', label: 'Israel', phone: '972' },
  { code: 'IM', label: 'Isle of Man', phone: '44' },
  { code: 'IN', label: 'India', phone: '91' },
  {
    code: 'IO',
    label: 'British Indian Ocean Territory',
    phone: '246',
  },
  { code: 'IQ', label: 'Iraq', phone: '964' },
  {
    code: 'IR',
    label: 'Iran, Islamic Republic of',
    phone: '98',
  },
  { code: 'IS', label: 'Iceland', phone: '354' },
  { code: 'JE', label: 'Jersey', phone: '44' },
  { code: 'JM', label: 'Jamaica', phone: '1-876' },
  { code: 'JO', label: 'Jordan', phone: '962' },
  {
    code: 'JP',
    label: 'Japan',
    phone: '81',
    suggested: true,
  },
  { code: 'KE', label: 'Kenya', phone: '254' },
  { code: 'KG', label: 'Kyrgyzstan', phone: '996' },
  { code: 'KH', label: 'Cambodia', phone: '855' },
  { code: 'KI', label: 'Kiribati', phone: '686' },
  { code: 'KM', label: 'Comoros', phone: '269' },
  {
    code: 'KN',
    label: 'Saint Kitts and Nevis',
    phone: '1-869',
  },
  {
    code: 'KP',
    // eslint-disable-next-line prettier/prettier
    label: 'Korea, Democratic People\'s Republic of',
    phone: '850',
  },
  { code: 'KR', label: 'Korea, Republic of', phone: '82' },
  { code: 'KW', label: 'Kuwait', phone: '965' },
  { code: 'KY', label: 'Cayman Islands', phone: '1-345' },
  { code: 'KZ', label: 'Kazakhstan', phone: '7' },
  {
    code: 'LA',
    // eslint-disable-next-line prettier/prettier
    label: 'Lao People\'s Democratic Republic',
    phone: '856',
  },
  { code: 'LB', label: 'Lebanon', phone: '961' },
  { code: 'LC', label: 'Saint Lucia', phone: '1-758' },
  { code: 'LI', label: 'Liechtenstein', phone: '423' },
  { code: 'LK', label: 'Sri Lanka', phone: '94' },
  { code: 'LR', label: 'Liberia', phone: '231' },
  { code: 'LS', label: 'Lesotho', phone: '266' },
  { code: 'LT', label: 'Lithuania', phone: '370' },
  { code: 'LU', label: 'Luxembourg', phone: '352' },
  { code: 'LV', label: 'Latvia', phone: '371' },
  { code: 'LY', label: 'Libya', phone: '218' },
  { code: 'MA', label: 'Morocco', phone: '212' },
  { code: 'MC', label: 'Monaco', phone: '377' },
  {
    code: 'MD',
    label: 'Moldova, Republic of',
    phone: '373',
  },
  { code: 'ME', label: 'Montenegro', phone: '382' },
  {
    code: 'MF',
    label: 'Saint Martin (French part)',
    phone: '590',
  },
  { code: 'MG', label: 'Madagascar', phone: '261' },
  { code: 'MH', label: 'Marshall Islands', phone: '692' },
  {
    code: 'MK',
    label: 'Macedonia, the Former Yugoslav Republic of',
    phone: '389',
  },
  { code: 'ML', label: 'Mali', phone: '223' },
  { code: 'MM', label: 'Myanmar', phone: '95' },
  { code: 'MN', label: 'Mongolia', phone: '976' },
  { code: 'MO', label: 'Macao', phone: '853' },
  {
    code: 'MP',
    label: 'Northern Mariana Islands',
    phone: '1-670',
  },
  { code: 'MQ', label: 'Martinique', phone: '596' },
  { code: 'MR', label: 'Mauritania', phone: '222' },
  { code: 'MS', label: 'Montserrat', phone: '1-664' },
  { code: 'MT', label: 'Malta', phone: '356' },
  { code: 'MU', label: 'Mauritius', phone: '230' },
  { code: 'MV', label: 'Maldives', phone: '960' },
  { code: 'MW', label: 'Malawi', phone: '265' },
  { code: 'MX', label: 'Mexico', phone: '52' },
  { code: 'MY', label: 'Malaysia', phone: '60' },
  { code: 'MZ', label: 'Mozambique', phone: '258' },
  { code: 'NA', label: 'Namibia', phone: '264' },
  { code: 'NC', label: 'New Caledonia', phone: '687' },
  { code: 'NE', label: 'Niger', phone: '227' },
  { code: 'NF', label: 'Norfolk Island', phone: '672' },
  { code: 'NG', label: 'Nigeria', phone: '234' },
  { code: 'NI', label: 'Nicaragua', phone: '505' },
  { code: 'NL', label: 'Netherlands', phone: '31' },
  { code: 'NO', label: 'Norway', phone: '47' },
  { code: 'NP', label: 'Nepal', phone: '977' },
  { code: 'NR', label: 'Nauru', phone: '674' },
  { code: 'NU', label: 'Niue', phone: '683' },
  { code: 'NZ', label: 'New Zealand', phone: '64' },
  { code: 'OM', label: 'Oman', phone: '968' },
  { code: 'PA', label: 'Panama', phone: '507' },
  { code: 'PE', label: 'Peru', phone: '51' },
  { code: 'PF', label: 'French Polynesia', phone: '689' },
  { code: 'PG', label: 'Papua New Guinea', phone: '675' },
  { code: 'PH', label: 'Philippines', phone: '63' },
  { code: 'PK', label: 'Pakistan', phone: '92' },
  { code: 'PL', label: 'Poland', phone: '48' },
  {
    code: 'PM',
    label: 'Saint Pierre and Miquelon',
    phone: '508',
  },
  { code: 'PN', label: 'Pitcairn', phone: '870' },
  { code: 'PR', label: 'Puerto Rico', phone: '1' },
  {
    code: 'PS',
    label: 'Palestine, State of',
    phone: '970',
  },
  { code: 'PT', label: 'Portugal', phone: '351' },
  { code: 'PW', label: 'Palau', phone: '680' },
  { code: 'PY', label: 'Paraguay', phone: '595' },
  { code: 'QA', label: 'Qatar', phone: '974' },
  { code: 'RE', label: 'Reunion', phone: '262' },
  { code: 'RO', label: 'Romania', phone: '40' },
  { code: 'RS', label: 'Serbia', phone: '381' },
  { code: 'RU', label: 'Russian Federation', phone: '7' },
  { code: 'RW', label: 'Rwanda', phone: '250' },
  { code: 'SA', label: 'Saudi Arabia', phone: '966' },
  { code: 'SB', label: 'Solomon Islands', phone: '677' },
  { code: 'SC', label: 'Seychelles', phone: '248' },
  { code: 'SD', label: 'Sudan', phone: '249' },
  { code: 'SE', label: 'Sweden', phone: '46' },
  { code: 'SG', label: 'Singapore', phone: '65' },
  { code: 'SH', label: 'Saint Helena', phone: '290' },
  { code: 'SI', label: 'Slovenia', phone: '386' },
  {
    code: 'SJ',
    label: 'Svalbard and Jan Mayen',
    phone: '47',
  },
  { code: 'SK', label: 'Slovakia', phone: '421' },
  { code: 'SL', label: 'Sierra Leone', phone: '232' },
  { code: 'SM', label: 'San Marino', phone: '378' },
  { code: 'SN', label: 'Senegal', phone: '221' },
  { code: 'SO', label: 'Somalia', phone: '252' },
  { code: 'SR', label: 'Suriname', phone: '597' },
  { code: 'SS', label: 'South Sudan', phone: '211' },
  {
    code: 'ST',
    label: 'Sao Tome and Principe',
    phone: '239',
  },
  { code: 'SV', label: 'El Salvador', phone: '503' },
  {
    code: 'SX',
    label: 'Sint Maarten (Dutch part)',
    phone: '1-721',
  },
  {
    code: 'SY',
    label: 'Syrian Arab Republic',
    phone: '963',
  },
  { code: 'SZ', label: 'Swaziland', phone: '268' },
  {
    code: 'TC',
    label: 'Turks and Caicos Islands',
    phone: '1-649',
  },
  { code: 'TD', label: 'Chad', phone: '235' },
  {
    code: 'TF',
    label: 'French Southern Territories',
    phone: '262',
  },
  { code: 'TG', label: 'Togo', phone: '228' },
  { code: 'TH', label: 'Thailand', phone: '66' },
  { code: 'TJ', label: 'Tajikistan', phone: '992' },
  { code: 'TK', label: 'Tokelau', phone: '690' },
  { code: 'TL', label: 'Timor-Leste', phone: '670' },
  { code: 'TM', label: 'Turkmenistan', phone: '993' },
  { code: 'TN', label: 'Tunisia', phone: '216' },
  { code: 'TO', label: 'Tonga', phone: '676' },
  { code: 'TR', label: 'Turkey', phone: '90' },
  {
    code: 'TT',
    label: 'Trinidad and Tobago',
    phone: '1-868',
  },
  { code: 'TV', label: 'Tuvalu', phone: '688' },
  {
    code: 'TW',
    label: 'Taiwan, Province of China',
    phone: '886',
  },
  {
    code: 'TZ',
    label: 'United Republic of Tanzania',
    phone: '255',
  },
  { code: 'UA', label: 'Ukraine', phone: '380' },
  { code: 'UG', label: 'Uganda', phone: '256' },
  { code: 'UY', label: 'Uruguay', phone: '598' },
  { code: 'UZ', label: 'Uzbekistan', phone: '998' },
  {
    code: 'VA',
    label: 'Holy See (Vatican City State)',
    phone: '379',
  },
  {
    code: 'VC',
    label: 'Saint Vincent and the Grenadines',
    phone: '1-784',
  },
  { code: 'VE', label: 'Venezuela', phone: '58' },
  {
    code: 'VG',
    label: 'British Virgin Islands',
    phone: '1-284',
  },
  {
    code: 'VI',
    label: 'US Virgin Islands',
    phone: '1-340',
  },
  { code: 'VN', label: 'Vietnam', phone: '84' },
  { code: 'VU', label: 'Vanuatu', phone: '678' },
  { code: 'WF', label: 'Wallis and Futuna', phone: '681' },
  { code: 'WS', label: 'Samoa', phone: '685' },
  { code: 'XK', label: 'Kosovo', phone: '383' },
  { code: 'YE', label: 'Yemen', phone: '967' },
  { code: 'YT', label: 'Mayotte', phone: '262' },
  { code: 'ZA', label: 'South Africa', phone: '27' },
  { code: 'ZM', label: 'Zambia', phone: '260' },
  { code: 'ZW', label: 'Zimbabwe', phone: '263' },
];
